import * as React from 'react';
import { IconSuccess16, Tooltip } from '@cian/ui-kit';
import { ArticleHeading5 } from '@cian/ui-kit/typography';
import { useDeviceType } from '@cian/ui-kit/responsive/hooks/useDeviceType';

import * as styles from './styles.css';

export interface ISuperAgentTooltipProps {
  isOnlyDesktop?: boolean;
  children: React.ReactElement;
}

const SUPERAGENT_INFO_LIST = [
  'Документы проверены',
  'Вежливо общается с клиентами',
  'Всегда отвечает на звонки и сообщения',
  'Соблюдает правила Циан',
];

export const SuperAgentTooltip: React.FC<ISuperAgentTooltipProps> = ({ children, isOnlyDesktop }) => {
  const isDesktop = useDeviceType() === 'desktop';

  if (isOnlyDesktop && !isDesktop) {
    return children;
  }

  return (
    <Tooltip
      theme="white"
      placement="bottom"
      title={
        <div className={styles['tooltip']}>
          <ArticleHeading5>Суперагент</ArticleHeading5>
          <ul className={styles['list']}>
            {SUPERAGENT_INFO_LIST.map(item => (
              <li key={item} className={styles['list-item']}>
                <IconSuccess16 color="theme-green" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      }
    >
      <div className={styles['container']}>{children}</div>
    </Tooltip>
  );
};

SuperAgentTooltip.displayName = 'SuperAgentTooltip';
